import baseApi from '@store/api/baseApi';

export const brandListApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		getCRMBrandList: builder.query({
			query: (searchParams) => ({
				url: `/brand/allWithLogo/list${searchParams}`
			}),
			providesTags: ['CRMBrandList']
		})
	})
});

export const { useGetCRMBrandListQuery } = brandListApi;
